import { render, staticRenderFns } from "./GenderPicker.vue?vue&type=template&id=63c335c7&scoped=true&"
import script from "./GenderPicker.vue?vue&type=script&lang=js&"
export * from "./GenderPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c335c7",
  null
  
)

export default component.exports